/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { find } from '../fn/user-global-settings-controller/find';
import { Find$Params } from '../fn/user-global-settings-controller/find';
import { updateById } from '../fn/user-global-settings-controller/update-by-id';
import { UpdateById$Params } from '../fn/user-global-settings-controller/update-by-id';
import { UserGlobalSettingsWithRelations } from '../models/user-global-settings-with-relations';

@Injectable({ providedIn: 'root' })
export class UserGlobalSettingsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userGlobalSettingsControllerFind()` */
  static readonly UserGlobalSettingsControllerFindPath = '/user/global-settings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: Find$Params, context?: HttpContext): Observable<StrictHttpResponse<UserGlobalSettingsWithRelations>> {
    return find(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: Find$Params, context?: HttpContext): Observable<UserGlobalSettingsWithRelations> {
    return this.find$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserGlobalSettingsWithRelations>): UserGlobalSettingsWithRelations => r.body)
    );
  }

  /** Path part for operation `userGlobalSettingsControllerUpdateById()` */
  static readonly UserGlobalSettingsControllerUpdateByIdPath = '/user/global-settings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params?: UpdateById$Params, context?: HttpContext): Observable<StrictHttpResponse<UserGlobalSettingsWithRelations>> {
    return updateById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params?: UpdateById$Params, context?: HttpContext): Observable<UserGlobalSettingsWithRelations> {
    return this.updateById$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserGlobalSettingsWithRelations>): UserGlobalSettingsWithRelations => r.body)
    );
  }

}
